<template>
    <div id="user-subscription">
        <img src="/images/remove-b.png" class="photo-preview-remove" v-bind:class="hasContent ? 'photo-preview-remove' : 'photo-preview-remove-hide'" id="subscr-clear">
        <canvas id="subscr-canvas" width="326" height="300"></canvas>
	
	</div>
</template>

<script>
export default {
    name: 'subscr-canvas',
	data() {
		return {
			hasContent: false
		}
	},	
	methods: {
		setValue: function (canvas) {
			this.hasContent = true
			this.$emit('input', canvas.toDataURL('image/png'))
		}
	},
	watch: {
		// current: function() {
		// 	console.log(this.current)
		// 	this.percentProgress = Math.round(this.current * this.step * 0.9) + "%"
		// 	this.element.style.width = this.percentProgress;
		// }
	},
	mounted() {
		let vcomp = this
		document.ontouchmove = function(e){ e.preventDefault(); }

        var canvas  = document.getElementById('subscr-canvas');
        var subscrContainer = document.getElementById('mainapp');
        var userSubscrContainer = document.getElementById("user-subscription")
        var leftShift = userSubscrContainer.getBoundingClientRect().left
		var canvastop = canvas.offsetTop + subscrContainer.offsetTop + 80

		var context = canvas.getContext("2d");
		let lineColor = "#002db3"

		var lastx;
		var lasty;

		context.strokeStyle = lineColor;
		context.lineCap = 'round';
		context.lineJoin = 'round';
		context.lineWidth = 2;

		function clear() {
			context.fillStyle = "#ffffff";
			context.rect(0, 0, 400, 400);
			context.fill();

			vcomp.setValue(canvas)
			vcomp.hasContent = false
		}

		function dot(x,y) {
			context.beginPath();
			context.fillStyle = lineColor;
			context.arc(x,y,1,0,Math.PI*2,true);
			context.fill();
			context.stroke();
			context.closePath();

			vcomp.setValue(canvas)
		}

		function line(fromx,fromy, tox,toy) {
			context.beginPath();
			context.moveTo(fromx, fromy);
			context.lineTo(tox, toy);
			context.stroke();
			context.closePath();

			vcomp.setValue(canvas)
		}

		canvas.ontouchstart = function(event){                   
			event.preventDefault();                 
            console.log(event.touches[0].clientX)
			lastx = event.touches[0].clientX - leftShift;
			lasty = event.touches[0].clientY - canvastop;

			dot(lastx,lasty);
		}

		canvas.ontouchmove = function(event){                   
			event.preventDefault();                 

			var newx = event.touches[0].clientX - leftShift;
			var newy = event.touches[0].clientY - canvastop;

			line(lastx,lasty, newx,newy);
			
			lastx = newx;
			lasty = newy;
		}

		document.onmousemove = function(event) {
			// console.log("move")
			if (event.buttons !== 1) return;

			event.preventDefault();                 

			var newx = event.clientX - leftShift;
            var newy = event.clientY - canvastop;
            
			line(lastx,lasty, newx,newy);
			
			lastx = newx;
			lasty = newy;
		}
		canvas.onmousedown = function(event) {
			event.preventDefault();              
		
			lastx = event.clientX - leftShift;
			lasty = event.clientY - canvastop;

			dot(lastx,lasty);
		}


		var clearButton = document.getElementById('subscr-clear')
		clearButton.onclick = clear

		clear()
	}
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/SubscriptionCanvas.vue